module.exports = __webpack_public_path__ + "media/images/bbq_map-abc37b1191ac1bee4a3db69438170343.png";